// Demo GL data (mock/jittered — not real financials)
// Synthetic monthly P&L dataset for demo purposes
// Period: Jan 2025 – Feb 2026 (14 months)
// Revenue accounts (4xxxx): positive = revenue earned
// Expense accounts (5-9xxxx): positive = expense incurred

export const GL_MONTHS = [
  '2025-01',
  '2025-02',
  '2025-03',
  '2025-04',
  '2025-05',
  '2025-06',
  '2025-07',
  '2025-08',
  '2025-09',
  '2025-10',
  '2025-11',
  '2025-12',
  '2026-01',
  '2026-02',
];

// Monthly net activity by P&L account
export const glMonthly = [
  { code: '49100', name: 'Grants Revenue', monthly: [0, 0, 0, 0, 0, 0, 0, 0, 0, 50570, 13377, 23919, 12192, 52227] },
  { code: '49200', name: 'SR&ED Refund', monthly: [0, 0, 0, 0, 0, 0, 0, 0, 0, -40555, 0, -161922, 0, 0] },
  { code: '49400', name: 'Interest Earned', monthly: [71131, 109693, 137068, 164839, 234621, 162262, 207885, 153348, 195079, 177027, 157386, 147563, 166041, 37461] },
  { code: '51010', name: 'Motors', monthly: [52141, 0, 0, -10055, 141673, 2980, 0, 5530, 333577, 15258, 78487, 0, 153199, 0] },
  { code: '51011', name: 'Device Component', monthly: [73483, 32193, 109957, 43874, 29180, 50349, 40470, 38216, 80597, 32591, 72750, 124222, 41942, 26758] },
  { code: '51020', name: 'Engineering Consulting Fees', monthly: [8587, 0, 11944, 0, 0, 0, 0, 0, 109482, 4912, 19336, 44670, 11364, 1761] },
  { code: '51030', name: 'Consumables', monthly: [0, 129, 12096, 629, 11348, 19213, 595845, 79855, 82632, 58427, 67672, 53022, 65037, 25589] },
  { code: '51040', name: 'Tools & Machine Tooling', monthly: [17598, 4283, 13247, 10715, 19575, 47972, 29947, 23913, 84534, 63204, 93531, 35790, 57457, 50716] },
  { code: '51050', name: 'Machine Repairs & Maintenance', monthly: [4122, 7380, 1063, 5603, 11553, -343, 18817, 100, 11697, 19954, 8258, 11987, 18884, 23640] },
  { code: '51055', name: 'Subcontractor - Manufacturing', monthly: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8411] },
  { code: '51060', name: 'Small Machines', monthly: [81484, 80908, 86830, 158164, 172706, 125805, -604763, 72828, 92085, 12213, 13400, 11586, 310, 1988] },
  { code: '51070', name: 'External Testing Costs', monthly: [466, 0, 0, 0, 0, 0, 0, 0, 11351, 0, 25997, 25646, 0, 2825] },
  { code: '52100', name: 'Animal Testing', monthly: [1274, 45725, 0, 70383, 0, 25902, 10665, 0, 94323, 135143, 35969, 93770, 0, 18294] },
  { code: '52110', name: 'Pre-Clinical - Other Testing', monthly: [0, 6805, 0, 0, 0, 0, 0, 0, 0, 650, 526, 1528, 0, 0] },
  { code: '52120', name: 'Pre-Clinical - Other Direct Costs', monthly: [0, 319, 0, 0, 0, 0, 0, 0, 397, 0, 6274, 3865, 5455, 0] },
  { code: '52200', name: 'EFS - Clinical Trial Costs', monthly: [716, 607, 680, 1243, 562, 652, 478, 0, 371, 0, 6205, 28806, 55019, 21912] },
  { code: '52240', name: 'EFS - Clinical Trials Other Costs', monthly: [0, 0, 0, 0, 0, 0, 0, 532, 0, 0, 0, 0, 4796, 0] },
  { code: '53100', name: 'Certifications & Compliance Audit', monthly: [179, 12228, 361, 313, 566, 341, 191, 0, 0, 0, 0, 0, 0, 5029] },
  { code: '61010', name: 'Salaries', monthly: [286943, 406237, 352929, 439502, 456594, 548977, 466341, 539749, 526960, 500378, 465393, 507075, 382591, 420868] },
  { code: '61020', name: 'Bonus', monthly: [0, 33, 0, 2036, 0, 0, 0, 0, 0, 0, 0, 630907, 0, 0] },
  { code: '61030', name: 'Vacation', monthly: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 42427, -48877, 0] },
  { code: '61040', name: 'Federal Payroll Taxes', monthly: [2683, 6767, 6147, 6956, 4208, 16182, 5415, 4088, -268, 7553, 1953, 184, -5429, 6880] },
  { code: '61050', name: 'Quebec Payroll Taxes', monthly: [20775, 26885, 40672, 35940, 28884, 30711, 26132, 23431, 39311, 32062, 28465, 81878, -1252, 51831] },
  { code: '61055', name: 'Payroll Taxes (US)', monthly: [3186, 20090, 4951, 5761, 4260, 3879, 4854, 3706, 2409, 2364, -6511, 2181, 3118, 2942] },
  { code: '61060', name: 'Employee Benefits - Health Plan', monthly: [4115, 5992, 6848, 10272, 13142, 15049, 6485, 15246, 16433, 14491, 11444, 9074, 10270, 12806] },
  { code: '61070', name: 'Employee Benefits - Cellphone', monthly: [0, 2283, -26, 1440, 1521, 1551, 997, 1435, 2237, 1653, 2312, 4070, 2504, 2376] },
  { code: '61080', name: 'Employee Benefits - Gym', monthly: [1161, 1485, 978, 694, 1254, 573, 531, 1054, 861, 662, 954, 702, 995, 1643] },
  { code: '62010', name: 'Contractor & Consulting fees', monthly: [7419, 10792, 2119, 56798, 12974, 34794, 17998, 2163, 40176, 1353, 0, -3740, 11032, 18242] },
  { code: '62110', name: 'Consulting fees', monthly: [0, 0, 220, 0, 0, 0, 0, 1113, 221, 11016, 21964, 67545, 0, 0] },
  { code: '63010', name: 'Corporate Insurance', monthly: [4076, 17042, 5668, 3867, 4168, 3477, 3823, 4893, 4824, 3829, 4478, 6256, 2819, 10289] },
  { code: '63020', name: 'Legal & Immigration', monthly: [6394, 23756, 12050, 37293, 19639, 8226, 14237, 3574, 13321, 2758, 0, 8908, 0, 6049] },
  { code: '63021', name: 'Patent Management & Patent Attorneys', monthly: [61228, 29529, 59215, 96033, 61880, 85379, 63607, 40937, 27046, 18496, 40978, 107145, 34711, 14824] },
  { code: '63030', name: 'Audit & Tax', monthly: [20048, 21496, 0, 14268, 0, 31676, 33736, 0, 0, 0, 0, 113450, -114303, 19293] },
  { code: '63050', name: 'Agency & Filing Fees', monthly: [0, 266, 1259, 0, 0, 447, 2993, 0, 0, 605, 423, 2, 282, 0] },
  { code: '64010', name: 'Payroll Services Fees', monthly: [659, 597, 689, 1078, 2177, 1588, 3783, 2021, 2918, 3423, 2068, 2932, 2286, 0] },
  { code: '64020', name: 'Recruiting Fees', monthly: [519, 0, 103876, 22923, 54009, 27328, 0, 0, 0, 1503, 14149, 29356, 2334, 30070] },
  { code: '64050', name: 'Team Training', monthly: [1223, 35, 22, 52, 88, 0, 0, 173, 57, 319, 807, 7278, 0, 0] },
  { code: '64060', name: 'Team Events & Gifts', monthly: [9121, 643, 0, 22512, 0, 0, 1074, 751, 0, 871, 1105, 4417, 4193, 1560] },
  { code: '64070', name: 'Team Meals', monthly: [5063, 2931, 3299, 2557, 1998, 4028, 2278, 2868, 2871, 8935, 3244, 4588, 4009, 2177] },
  { code: '64090', name: 'Team Gifts', monthly: [0, 28, 1857, 0, 1232, 0, 0, 150, 0, 555, 218, 0, 1544, 792] },
  { code: '65010', name: 'Rent', monthly: [23652, 45078, 26233, 37048, 19106, 30876, 51456, 67348, 56160, 19327, 64932, 58525, 88513, 84190] },
  { code: '65020', name: 'Rent Expense (Free Rent)', monthly: [-1918, -27790, -21830, 26132, 25916, 10778, 3683, -22428, 19678, 50430, 36630, 35404, -32887, -29087] },
  { code: '65021', name: 'Rent Expense (LHI)', monthly: [-10411, -10669, -20280, -18713, -24365, -22841, -24229, -25165, -19323, -18918, -19415, -25902, -21100, -24148] },
  { code: '65022', name: 'Rent - Opex', monthly: [19489, 38775, 35725, 13708, 2111, 19307, 23005, 36433, -172, -26682, -14649, -11409, 33575, 32639] },
  { code: '65030', name: 'Internet', monthly: [333, 221, 451, 0, 1278, 769, 2010, 1061, 1185, 216, 0, 0, 6, 2625] },
  { code: '65040', name: 'Office Cleaning & Maintenance', monthly: [0, 0, 0, 0, 0, 0, 0, 0, 4417, 5927, 9032, 12539, 4032, 8102] },
  { code: '65050', name: 'Repairs & Maintenance', monthly: [0, 0, 0, 0, 0, 359, 1513, 0, 1110, 860, 8167, 10023, 8823, 2327] },
  { code: '66010', name: 'Software Subscriptions', monthly: [19299, 53316, 29985, 90211, 39414, 60377, 35796, 30958, 34132, 35922, 33156, 37302, 111554, 42372] },
  { code: '66030', name: 'IT Supplies & Small Equipments', monthly: [14176, 5282, 9318, 6131, 9106, 1426, 4110, 3083, 9566, 10533, 13120, 9495, 2381, 1810] },
  { code: '66040', name: 'Custom, Duties, Brokerage Fees', monthly: [17962, 11826, 15278, 17387, 15746, 15826, 13619, 14041, 20059, 19844, 22558, 18011, 9114, 17139] },
  { code: '66050', name: 'Shipping Expenses', monthly: [0, 0, 0, 0, 0, 0, 0, 5043, 355, 240, 169, 0, 1310, 41] },
  { code: '66060', name: 'Office & Team Supplies', monthly: [49712, 25393, 17723, 29048, 16044, 24430, 27310, 5404, 6074, 23186, 35137, 4519, 17801, 17755] },
  { code: '66070', name: 'Miscellaneous', monthly: [7337, -8698, -732, 2032, 4284, -677, -7193, 3, 172, 294, 0, 5889, 137, 0] },
  { code: '66080', name: 'Exceptional gains or losses', monthly: [-61436, 0, 0, 0, 0, 0, -23605, 0, 0, -37642, 0, 0, 0, 0] },
  { code: '67010', name: 'Travel & Hotel', monthly: [7909, 7663, 3371, 5915, 8989, 6980, 11682, 169, 5764, 6855, 57685, -34826, 60137, 222] },
  { code: '67020', name: 'Hotel', monthly: [0, 0, 0, 0, 0, 0, 69, 0, 0, 8932, 1675, 0, 0, 0] },
  { code: '67030', name: 'Business Meals', monthly: [0, 0, 0, 0, 0, 589, 2517, 359, 18, 5633, 19, 3949, 1346, 2240] },
  { code: '67040', name: 'Conferences', monthly: [0, 0, 0, 0, 0, 0, 385, 0, 0, 7285, 0, 0, 0, 0] },
  { code: '68010', name: 'Bank Charges', monthly: [1180, 1582, 1352, 1126, 1374, 2101, 5674, 1020, 768, 682, 1981, 809, 984, 1023] },
  { code: '68011', name: 'Non-Deductible Interest & Penalty Expense', monthly: [0, 0, 0, 0, 0, 0, 111, 0, 543, 0, 0, 3724, 0, -2179] },
  { code: '70010', name: 'FX Gain or Loss', monthly: [974222, 658, -8081, -8628, -10646, 13375, -223312, 208, 548, 13063, 794, -11529, 3034, -4825] },
  { code: '70020', name: 'Unrealized FX Gain or Loss', monthly: [-891846, 146026, 129444, 2263057, 201549, 324159, -384000, 281894, -700562, -309404, 120279, 742738, 197369, -107637] },
  { code: '70100', name: 'Deemed Interest on Loans', monthly: [2623, 1988, 1977, 2252, 2015, 2150, 2184, 1785, 2164, 1624, 1526, 2164, 1619, 1610] },
  { code: '70200', name: 'Gain or loss on disposal', monthly: [0, -22707, -1384, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
  { code: '90015', name: 'Depreciation - LHI', monthly: [17249, 18085, 20418, 15436, 17691, 21065, 25279, 22431, 24693, 31257, 28403, 23914, 26951, 24667] },
  { code: '90025', name: 'Deprecation - CLR', monthly: [2054, 2399, 2320, 2123, 2120, 2043, 2026, 2584, 2505, 2210, 2804, 2252, 2372, 2742] },
  { code: '90035', name: 'Deprecation - ME', monthly: [17996, 24265, 20965, 27363, 27403, 34632, 29598, 26070, 35575, 29187, 30007, 39574, 30464, 39249] },
  { code: '90045', name: 'Deprecation - FF', monthly: [2611, 2408, 2974, 4407, 3709, 4834, 4761, 3822, 4503, 5333, 4259, 5803, 6317, 5358] },
  { code: '90055', name: 'Deprecation - CE', monthly: [3350, 3967, 3851, 4525, 4145, 5639, 6273, 6654, 5451, 7376, 7361, 5032, 7608, 5655] },
];

// Structured P&L sections for GL Variance view
// Returns { section, accounts: [{ code, name, monthly: [16] }] }
export function getCompanyGLSections() {
  const sections = [
    { section: 'Other Revenues', codes: ['49100', '49400'] },
    { section: 'R&D — Manufacturing', codes: ['51010', '51011', '51020', '51030', '51040', '51050', '51060', '51070'] },
    { section: 'R&D — Clinical & Pre-Clinical', codes: ['52100', '52200', '53100'] },
    { section: 'Payroll & Benefits', codes: ['61010', '61020', '61040', '61050', '61055', '61060'] },
    { section: 'Professional & Legal', codes: ['62010', '62110', '63010', '63020', '63021', '63030'] },
    { section: 'Facilities', codes: ['65010', '65022', '65040', '65050'] },
    { section: 'IT & Software', codes: ['66010', '66030', '66040', '66060'] },
    { section: 'HR & People', codes: ['64020', '64060', '64070'] },
    { section: 'Travel', codes: ['67010', '67030', '67040'] },
    { section: 'FX & Other', codes: ['70010', '70020', '68010'] },
    { section: 'Depreciation', codes: ['90015', '90025', '90035', '90045', '90055'] },
  ];

  const lookup = Object.fromEntries(glMonthly.map(a => [a.code, a]));

  return (monthIdx) => {
    // monthIdx: 0-13 maps to GL_MONTHS[0..13]
    // Returns format for GLVarianceTable: { section, accounts: [{ code, name, jan (prior), feb (current) }] }
    const prior = Math.max(0, monthIdx - 1);
    return sections.map(s => ({
      section: s.section,
      accounts: s.codes
        .map(code => lookup[code])
        .filter(Boolean)
        .map(a => ({
          code: a.code,
          name: a.name,
          jan: a.monthly[prior],
          feb: a.monthly[monthIdx],
        })),
    }));
  };
}

// P&L Variance Analysis — rolling average comparison
export function getCompanyGLHistory(monthIdx) {
  // Return key accounts with their monthly arrays up to monthIdx
  const keyCodes = [
    '49400', '49100', '61010', '61020', '51030', '51011', '51010',
    '52100', '63021', '66010', '65010', '64020', '63030', '63020',
    '62010', '70020', '90035', '90015',
  ];
  const lookup = Object.fromEntries(glMonthly.map(a => [a.code, a]));
  return keyCodes
    .map(code => lookup[code])
    .filter(Boolean)
    .map(a => ({
      code: a.code,
      name: a.name,
      monthly: a.monthly.slice(Math.max(0, monthIdx - 11), monthIdx + 1),
    }));
}

// Departments — generic engineering/operations org taxonomy (demo)
export const DEPARTMENTS = [
  { key: 'all', label: 'All Company' },
  { key: 'machine-shop', label: 'Machine Shop & Metrology' },
  { key: 'cleanroom', label: 'Cleanroom' },
  { key: 'facilities', label: 'Facilities' },
  { key: 'supply-chain', label: 'Supply Chain' },
  { key: 'operations', label: 'Operations (Device)' },
  { key: 'design', label: 'Design' },
  { key: 'mech-design', label: 'Mechanical Design' },
  { key: 'elec-software', label: 'Electrical & Software' },
  { key: 'clinical-reg', label: 'Clinical & Regulatory' },
  { key: 'quality', label: 'Quality' },
  { key: 'dc-testing', label: 'Design Control & Testing' },
  { key: 'ip', label: 'Intellectual Property' },
  { key: 'it', label: 'IT' },
  { key: 'people', label: 'People & Culture' },
  { key: 'finance', label: 'Finance & Legal' },
  { key: 'executive', label: 'Executive' },
];

// Budget by department — demo allocation (mock figures)
// Actuals derived from the demo GL dataset (Feb 2026 = glMonthly index 13)
export const BUDGET_BY_DEPT = {
  all: [
    // CASH-IN
    { category: 'Interest Income', budget: 1435998, actual: 1395057, isIncome: true },
    { category: 'Grants (iRAP, SR&ED)', budget: 115424, actual: 37694, isIncome: true },
    // CASH-OUT -- Operating
    { category: 'Salaries & Payroll Taxes', budget: 5071221, actual: 5099050 },
    { category: 'R&D -- Manufacturing', budget: 1710912, actual: 1912079 },
    { category: 'R&D -- Clinical & Preclinical', budget: 573398, actual: 548049 },
    { category: 'Professional & Consulting', budget: 174422, actual: 167168 },
    { category: 'Legal, IP & Audit', budget: 410553, actual: 515637 },
    { category: 'Employee Benefits & People', budget: 104229, actual: 95628 },
    { category: 'Facilities & Rent', budget: 498132, actual: 544349 },
    { category: 'Software, IT & Supplies', budget: 378889, actual: 427379 },
    { category: 'Travel & Meals', budget: 88652, actual: 62804 },
    { category: 'Certifications & Compliance', budget: 9516, actual: 4010 },
    { category: 'Bank Charges & Other', budget: 10302, actual: 5387 },
    // CASH-OUT -- Capital & Investing
    { category: 'Leasehold Improvements', budget: 653798, actual: 670636 },
    { category: 'Machinery & Equipment', budget: 200373, actual: 183912 },
    { category: 'Furniture & Computer Equipment', budget: 87316, actual: 69181 },
    { category: 'Vendor Deposits', budget: 1036754, actual: 827200 },
    { category: 'Rental Deposits', budget: 107277, actual: 86900 },
    // CASH-OUT -- Financing
    { category: 'Loan Repayment (DEC)', budget: 47403, actual: 39730 },
  ],
  'machine-shop': [
    { category: 'Small Machines (51060)', budget: 5044, actual: 1746 },
    { category: 'Consumables (51030)', budget: 39838, actual: 25156 },
    { category: 'Tools & Tooling (51040)', budget: 53776, actual: 71498 },
    { category: 'Machine Repairs (51050)', budget: 26766, actual: 23604 },
    { category: 'Subcontractor Mfg (51055)', budget: 9807, actual: 8787 },
    { category: 'Software (66010)', budget: 4208, actual: 3922 },
  ],
  cleanroom: [
    { category: 'Consumables (51030)', budget: 7063, actual: 0 },
    { category: 'Machine Repairs (51050)', budget: 3595, actual: 0 },
    { category: 'Software (66010)', budget: 2182, actual: 0 },
  ],
  facilities: [
    { category: 'Cleaning & Maintenance (65040)', budget: 9628, actual: 9070 },
    { category: 'Repairs & Maintenance (65050)', budget: 4691, actual: 2349 },
    { category: 'Furniture (15040)', budget: 2879, actual: 0 },
    { category: 'Software (66010)', budget: 982, actual: 0 },
    { category: 'Office Supplies (66060)', budget: 4653, actual: 20421 },
  ],
  'supply-chain': [
    { category: 'Customs & Duties (66040)', budget: 22404, actual: 17950 },
    { category: 'Shipping (66050)', budget: 1954, actual: 41 },
    { category: 'Software — Procurify (66010)', budget: 1718, actual: 0 },
  ],
  operations: [
    { category: 'Device Components (51011)', budget: 41653, actual: 23543 },
    { category: 'Motors (51010)', budget: 45992, actual: 0 },
  ],
  design: [
    { category: 'Consulting (62010)', budget: 6754, actual: 0 },
    { category: 'Software (66010)', budget: 3055, actual: 0 },
  ],
  'mech-design': [
    { category: 'Engineering Consulting (51020)', budget: 12584, actual: 1757 },
    { category: 'Fixtures & Jigs (51025)', budget: 1062, actual: 197 },
    { category: 'Consumables (51030)', budget: 5893, actual: 0 },
    { category: 'Software — CAD/FEA (66010)', budget: 7216, actual: 4384 },
  ],
  'elec-software': [
    { category: 'Device Components (51011)', budget: 12325, actual: 0 },
    { category: 'Engineering Consulting (51020)', budget: 4744, actual: 0 },
    { category: 'Consumables (51030)', budget: 2498, actual: 0 },
    { category: 'External Testing (51070)', budget: 5879, actual: 2474 },
    { category: 'Software — EDA/IDE (66010)', budget: 9589, actual: 4442 },
  ],
  'clinical-reg': [
    { category: 'Animal Testing (52100)', budget: 27815, actual: 19228 },
    { category: 'EFS Clinical Trials (52200)', budget: 28263, actual: 20056 },
    { category: 'Consulting (62010)', budget: 11275, actual: 0 },
    { category: 'Software (66010)', budget: 1873, actual: 0 },
  ],
  quality: [
    { category: 'Certifications & Audit (53100)', budget: 5643, actual: 4476 },
    { category: 'QMS Consulting (62010)', budget: 5487, actual: 0 },
    { category: 'Software — Greenlight (66010)', budget: 2541, actual: 0 },
  ],
  'dc-testing': [
    { category: 'External Testing (51070)', budget: 4037, actual: 0 },
    { category: 'Consulting (62010)', budget: 2544, actual: 0 },
    { category: 'Software (66010)', budget: 2341, actual: 0 },
  ],
  ip: [
    { category: 'Patent Mgmt & Attorneys (63021)', budget: 44836, actual: 15124 },
    { category: 'Software — IP tools (66010)', budget: 2300, actual: 0 },
  ],
  it: [
    { category: 'IT Supplies & Equipment (66030)', budget: 5069, actual: 1943 },
    { category: 'Internet (65030)', budget: 2482, actual: 2449 },
    { category: 'Software — Company-wide (66010)', budget: 26377, actual: 27125 },
  ],
  people: [
    { category: 'Benefits — Health (61060)', budget: 14998, actual: 10392 },
    { category: 'Benefits — Cellphone (61070)', budget: 2680, actual: 2531 },
    { category: 'Benefits — Gym (61080)', budget: 1646, actual: 1438 },
    { category: 'Recruiting Fees (64020)', budget: 36642, actual: 29274 },
    { category: 'Legal & Immigration (63020)', budget: 7095, actual: 7903 },
    { category: 'Team Events & Gifts (64060)', budget: 5804, actual: 1498 },
    { category: 'Team Meals (64070)', budget: 4191, actual: 2689 },
  ],
  finance: [
    { category: 'Consulting (62010)', budget: 9322, actual: 18082 },
    { category: 'Corporate Insurance (63010)', budget: 4759, actual: 9040 },
    { category: 'Legal — Corporate (63020)', budget: 5490, actual: 0 },
    { category: 'Audit & Tax (63030)', budget: 23792, actual: 20343 },
    { category: 'Software — Sage/Claude (66010)', budget: 5264, actual: 4659 },
    { category: 'Bank Charges (68010)', budget: 1264, actual: 934 },
  ],
  executive: [
    { category: 'Software (66010)', budget: 1987, actual: 0 },
    { category: 'Travel & Conferences (67010)', budget: 9850, actual: 212 },
    { category: 'Business Meals (67030)', budget: 2998, actual: 2567 },
  ],
};

export function getCompanyBudget(department) {
  return BUDGET_BY_DEPT[department || 'all'] || BUDGET_BY_DEPT.all;
}

// GL account → parent department mapping (for Spend by Department)
// Demo mapping for a generic engineering/operations org.
// For shared accounts (e.g. 51030 Consumables appears in Machine Shop, Cleanroom, Mech Design,
// Facilities, etc.), we assign to the PRIMARY department where most spend occurs.
// 66010 (Software) is distributed across all depts — assigned to IT as primary holder.
const ACCT_TO_PARENT = {
  // Operations (device components + motors)
  '51011': 'Operations', '51010': 'Operations',
  // Machine Shop (part of Operations parent)
  '51060': 'Operations', '51030': 'Operations', '51040': 'Operations',
  '51050': 'Operations', '51055': 'Operations',
  // Supply Chain (part of Operations parent)
  '66040': 'Operations', '66050': 'Operations',
  // Facilities (part of Operations parent)
  '65040': 'Operations', '65050': 'Operations', '66060': 'Operations',
  // Mechanical R&D (Design + Mechanical Design)
  '51020': 'Mechanical R&D', '51025': 'Mechanical R&D',
  // Electrical & Software
  '51070': 'Electrical & Software',
  // Clinical & Regulatory (animal testing, clinical trials, pre-clinical)
  '52100': 'Clinical & Regulatory', '52110': 'Clinical & Regulatory',
  '52120': 'Clinical & Regulatory', '52200': 'Clinical & Regulatory', '52240': 'Clinical & Regulatory',
  // Quality
  '53100': 'Quality',
  // IP
  '63021': 'IP', '63050': 'IP',
  // IT (software, internet, IT supplies)
  '66030': 'IT', '65030': 'IT', '66010': 'IT',
  // People & Culture
  '61060': 'People & Culture', '61070': 'People & Culture', '61080': 'People & Culture',
  '64020': 'People & Culture', '64060': 'People & Culture', '64070': 'People & Culture',
  '64050': 'People & Culture', '64090': 'People & Culture', '64010': 'People & Culture',
  // Finance & Legal
  '62010': 'Finance & Legal', '62110': 'Finance & Legal', '63010': 'Finance & Legal',
  '63020': 'Finance & Legal', '63030': 'Finance & Legal', '68010': 'Finance & Legal', '68011': 'Finance & Legal',
  // Executive
  '67010': 'Executive', '67020': 'Executive', '67030': 'Executive', '67040': 'Executive',
};

// Compute spend by parent department for a given set of month indices
export function getSpendByParentDept(monthIndices) {
  const parentTotals = {};
  const parentAccounts = {};

  for (const acct of glMonthly) {
    const parent = ACCT_TO_PARENT[acct.code];
    if (!parent) continue;

    const periodTotal = monthIndices.reduce((s, i) => s + (acct.monthly[i] || 0), 0);
    if (periodTotal <= 0) continue; // skip revenue/negative

    if (!parentTotals[parent]) { parentTotals[parent] = 0; parentAccounts[parent] = []; }
    parentTotals[parent] += periodTotal;
    parentAccounts[parent].push({ code: acct.code, name: acct.name, amount: periodTotal });
  }

  return Object.keys(parentTotals)
    .map(dept => ({
      dept,
      total: parentTotals[dept],
      accounts: parentAccounts[dept].sort((a, b) => b.amount - a.amount),
    }))
    .sort((a, b) => b.total - a.total);
}

// Cash flow by department
const CASHFLOW_BY_DEPT = {
  all: null, // uses default
  engineering: [
    { month: 'Sep', inflow: 0, outflow: 346572 },
    { month: 'Oct', inflow: 0, outflow: 320114 },
    { month: 'Nov', inflow: 0, outflow: 466285 },
    { month: 'Dec', inflow: 0, outflow: 423010 },
    { month: 'Jan', inflow: 0, outflow: 451731 },
    { month: 'Feb', inflow: 0, outflow: 292450 },
  ],
  'clinical-reg': [
    { month: 'Sep', inflow: 0, outflow: 166034 },
    { month: 'Oct', inflow: 0, outflow: 127911 },
    { month: 'Nov', inflow: 0, outflow: 98724 },
    { month: 'Dec', inflow: 0, outflow: 189618 },
    { month: 'Jan', inflow: 0, outflow: 67790 },
    { month: 'Feb', inflow: 0, outflow: 68942 },
  ],
};

export function getDepartmentCashFlow(department) {
  return CASHFLOW_BY_DEPT[department] || null;
}
